import { useSelector } from 'react-redux'
import PostFeed from '../../components/MyPostFeed' 
import styled from 'styled-components'
import ChoosePostPage from '../../components/postComponents/ChoosePostPage'
import Sidebar from 'components/Sidebar'

function MyProfile() {

  const { user } = useSelector((state) => state.auth)

  return (
    <>
        {user.isOrganization || user.isChurch ? (
            <ProfileRow>
                <ProfileLeft>
                    <Sidebar/>
                </ProfileLeft>  

                <UserProfileMain>
                    {/* <UserProfileTop /> */}
                    <PostFeed name={'user'} />
                 </UserProfileMain>
            </ProfileRow>
        )
        :
        (
            <ProfileRow>
                <ProfileLeft>
                    <Sidebar />
                </ProfileLeft>  



                <UserProfileMain>

                    <UPMTop>
                        <ChoosePostPage /> 
                    </UPMTop>

                    
                    <PostFeed name={'churchUser'} />

                </UserProfileMain>
            </ProfileRow>
        )}
    </>
)
}
export default MyProfile

const UserProfileMain = styled.div`
    margin-left: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;

`

const ProfileRow = styled.div`
    display: flex;
    width: 1300px;
    flex-direction: row;
    justify-content: flex-start; 
    margin: 0 auto;
    @media (max-width: 868px) {
      width: 100%;
    }
`
const UPMTop = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const ProfileLeft = styled.div`
    display: flex;
    flex-direction: column;
`